import React, { useState, useContext } from "react";
import {
    InputCopy,
    FormGroup,
    Select,
    Tooltip,
    StatusDot,
    Checkbox,
    Subheader,
    Button,
    Head,
    Card,
    Collapse,
    Input,
    FormFooter,
    Textarea,
    ContentBlock,
    RadioGroup,
    Switch,
    Icon,
    ButtonAction,
    Tag,
    Notification,
    CheckboxGroup
} from 'xsolla-uikit';
import PAtabs from "./PAtabs";

import styled from "styled-components";

import { IntlProvider } from "react-intl";

import { ProductIcon } from "../data/ProductIcon";
import PAviGroup from "./ingame/PAviGroup";

import PAmodal from "./PApop";
import PAh2 from "./PAh2";

import { vi, vpromos, subs } from "../data";
import { vc } from "../data/vc";

import { PAinfoCollapsible } from './uikit2';


export function PAConnectorCard({
  appearance = "md",
  header = "Connector Name",
  icon,
  text,
  connected = false,
  submitActive = false,
  footer = true,
  valid = false,
  children
}) {
  const [state, setState] = useState({
    connected: connected,
    pop: false
  });

  const handleModal = () => {
    setState({
      pop: false
    });
  };

  const handleConnect = () => {
    setState({
      connected: true
    });
  };

  return (
    <CssConnector style={{ justifySelf: "stretch" }}>
      {state.pop && (
        <PAmodal
          closeButton={false}
          size={appearance}
          header={header}
          handleModal={handleModal}
          handleConnect={handleConnect}
          submitActive={submitActive}
          footer={footer !== false ? <FormFooter>
              <Button
                appearance="outline"
                onClick={() => {
                  handleModal();
                }}
              >
                Discard
              </Button>
              <Button
                appearance="primary"
                disabled = {submitActive ? false : true}
                onClick={() => {
                  handleModal();
                  // handleConnect();
                }}
              >
                Connect
              </Button>
            </FormFooter> : false}
        >
          {children}
        </PAmodal>
      )}

      <div
        className="gateway-card gateway-card--click-enabled"
        style={{ height: "100%", width: "auto" }}
        onClick={() => {
          setState({
            // connected: !state.connected,
            pop: !state.pop
          });
        }}
      >
        <div style={{ padding: "16px 16px 0 16px", display: "flex" }}>
          <div style={{ flexGrow: 1 }}>
            {/* <h4 style={{ lineHeight: "120%" }}>{header}</h4> */}
            <PAh2 tag="h4" title={header} />
          </div>

          <ProductIcon
            // size="xs"
            width={24}
            height={24}
            name={icon}
          />

          {/* <div className={`card-app__image card-app__image--${icon}`}
            style={{backgroundSize:'cover'}}
          /> */}
        </div>

        {Boolean(text) && <div
          className="ui-form__input-description"
          style={{
            padding: "8px 16px 24px 16px",
            display: "flex",
            flexGrow: 1
          }}
        >
          <div className="xsui-typography--caption">{text}</div>
        </div>}

        <div className="gateway-card__delimiter" />
        <div className="gateway-card__content">


        <ConnectButton connected={state.connected}></ConnectButton>

        </div>
      </div>
    </CssConnector>
  );
}

const CssConnector = styled.div`
  & .connect-on-hover {
    display: none;
  }
  &:hover .connect-on-hover {
    display: block;
  }
  &:hover .connect-no-hover {
    display: none;
  }
`


const ConnectButton = ({connected}) => {
  return (<div className="gateways-list__item-panel">
  <span className="gateways-list__item-panel-configure">


      {Boolean(connected) && <div className="connect-on-hover">
        <Button appearance='flatten'>Edit</Button>
      </div>}


      <div className="connect-no-hover">
        {connected !== 'pending' && Boolean(connected) && (
          <Button appearance='flatten' style={{color: '#0bb200'}}>
            Connected</Button>
        )}
        {connected === 'pending' && (
          <Button
            style={{color: '#ff8111'}}
            appearance='flatten'>
            Pending...</Button>
        )}
      </div>




        {!connected && (
          <Button appearance='flatten'>
            Connect</Button>
        )}


  </span>
</div>)
}


const CssProductIcon = styled(ProductIcon)`

`;

export function PAconnectorGA({
  text = "Track and report your site's traffic."
}) {
  return (
    <PAConnectorCard
      header="Google Analytics"
      text={text}
      connected={false}
      icon="googleAnalytics"
    >
      <FormGroup label="Google Analytics ID" indentation="md">
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="UA-XXXXX-Y"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Google Analytics ID:{" "}
          <ol>
            <li>Sign in to your Analytics account.</li>
            <li>
              Click <strong>Admin</strong>.
            </li>
            <li>
              Select an account from the menu in the <strong>Account</strong>{" "}
              column.
            </li>
            <li>
              Select a property from the menu in the <strong>Property</strong>{" "}
              column.
            </li>
            <li>
              Under <strong>Property</strong>, click{" "}
              <strong>Tracking Info</strong> &gt; <strong>Tracking Code</strong>
              .
            </li>
          </ol>
          Your Google Analytics ID is displayed at the top of the page.
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}


export function PAconnectorXsollaDigest({
  text = "Get weekly analytics about your game from our payment specialists"
}) {
  return (
    <PAConnectorCard
      header="Get updates"
      text={text}
      connected={false}
      icon="digest"
      footer={false}
    >

  <FormGroup border='lg'>
      <FormGroup label="" indentation="md">
        <p>Subscribe m.miroshnikov@xsolla.com to a </p>
        <RadioGroup
          direction='row'
          input={{

            name: "subsDigest",
            value: 1,
            onChange: () => {
              void 0;
            }
          }}
          options={[
          {
            label: 'Weekly',
            radioValue: 1
          },
          {
            label: 'Bi-weekly',
            radioValue: 2
          },
          {
            label: 'Monthly',
            radioValue: 3
          },
        ]
        }/>
</FormGroup>

<FormGroup  indentation='md'>
  <Button size='md' appearance={'secondary'}>Submit</Button>
</FormGroup>

      </FormGroup>

<PAh2 title='Send to a co-worker' tag='h4'></PAh2>
      <FormGroup
        indentation="sm"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="username@domain.com"
        />
      </FormGroup>
      <FormGroup>
        <Button appearance='flatten' ><Icon name='add'/>Add another</Button>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorZapier({
  text = "Sync customers' data with any other service."
}) {
  return (
    <PAConnectorCard
      header="Zapier"
      text={text}
      connected={false}
      icon="zapier"
    >
      <FormGroup label="Zapier API key" indentation="md">
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="UA-XXXXX-Y"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Google Analytics ID:{" "}
          <ol>
            <li>Sign in to your Analytics account.</li>
            <li>
              Click <strong>Admin</strong>.
            </li>
            <li>
              Select an account from the menu in the <strong>Account</strong>{" "}
              column.
            </li>
            <li>
              Select a property from the menu in the <strong>Property</strong>{" "}
              column.
            </li>
            <li>
              Under <strong>Property</strong>, click{" "}
              <strong>Tracking Info</strong> &gt; <strong>Tracking Code</strong>
              .
            </li>
          </ol>
          Your Google Analytics ID is displayed at the top of the page.
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}


export function PAconnectorForum({
  text = "Track and report your site's traffic."
}) {
  return (
    <PAConnectorCard
      header="Forum"
      text={text}
      connected={false}
      icon="forum"
    >
      <FormGroup label="Forum API ID" indentation="md">
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="UA-XXXXX-Y"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Google Analytics ID:{" "}
          <ol>
            <li>Sign in to your Analytics account.</li>
            <li>
              Click <strong>Admin</strong>.
            </li>
            <li>
              Select an account from the menu in the <strong>Account</strong>{" "}
              column.
            </li>
            <li>
              Select a property from the menu in the <strong>Property</strong>{" "}
              column.
            </li>
            <li>
              Under <strong>Property</strong>, click{" "}
              <strong>Tracking Info</strong> &gt; <strong>Tracking Code</strong>
              .
            </li>
          </ol>
          Your Google Analytics ID is displayed at the top of the page.
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorFB({
  text = "Add the Facebook pixel to your website to measure the impact of your ads."
}) {
  return (
    <PAConnectorCard
      header="Facebook Pixel"
      text={text}
      connected={false}
      icon="facebookPixel"
    >
      <FormGroup
        label="Facebook Pixel ID"
        indentation="md"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="GTM-XXXXXXXXX"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Facebook Pixel ID:
          <ol>
            <li>
              Log in to Facebook and go to your{" "}
              <a style={{color: '#0073f7', textDecoration: 'underline',}} href="https://www.facebook.com/ads/manager" target="_blank">
                Ads Manager account
              </a>
            </li>
            <li>Open the Navigation Bar and select Pixels.</li>
            <li>Get your Pixel ID is under your Site name.</li>
          </ol>
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorPN({
  header = "Xsolla Partner Network",
  children = `<span>Create and manage influencer programs and affiliate campaigns. <a href="https://developers.xsolla.com/doc/partner_network/" target="_blank">Learn more</a></span>`
}) {
  return (
    <PAConnectorCard
      header={header}
      text={children}
      connected={false}
      icon="partner_network"
    >
      <FormGroup
        label="Facebook Pixel ID"
        indentation="md"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="GTM-XXXXXXXXX"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Facebook Pixel ID:
          <ol>
            <li>
              Log in to Facebook and go to your{" "}
              <a style={{color: '#0073f7', textDecoration: 'underline',}} href="https://www.facebook.com/ads/manager" target="_blank">
                Ads Manager account
              </a>
            </li>
            <li>Open the Navigation Bar and select Pixels.</li>
            <li>Get your Pixel ID is under your Site name.</li>
          </ol>
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorGTM({
  header = "Google Tag Manager",
  children = `Manage JavaScript and HTML tags used to track your site's traffic.`
}) {
  return (
    <PAConnectorCard
      header={header}
      text={children}
      connected={false}
      icon="googleTagManager"
    >
      <FormGroup
        label="GTM container ID"
        indentation="md"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="GTM-XXXXXXXXX"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          Go to <a href='#' style={{color: '#0073f7', textDecoration: 'underline',}}>Google Tag Manager Workspace</a>. Your Container ID is at the top
          of the window. Format: GTM-XXXXXX.
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorChatSlack({
  connected = false,
  header = "Xsolla Slack bot",
  children,
  handleSubmitButton = () => {
    void 0;
  }
}) {
  // let requiredFields = [
  //   apikey,
  //   list
  // ]

  let [apikey, setApikey] = React.useState(null);
  let [list, setList] = React.useState();
  let [submitActive, setSubmitActive] = React.useState(false);

  let [fetching, setFetching] = React.useState(false);

  let apiInput = React.createRef();

  let fetchTime = null;

  React.useEffect(() => {
    let active = true;
    // [apikey, list].forEach((oneReq, ind)=> {
    //   if (!oneReq) active = false;
    // })
    if (!apikey || (apikey && apikey.length !== 16)) active = false;
    // if (!list) active = false;

    if (apikey && apikey.length === 16 && !fetching) {
      setFetching(true);
      fetchTime = setTimeout(() => {
        setFetching(false);
      }, 800);
    }
    console.log("fetching = ", fetching);
    setSubmitActive(active);
    return () => {
      if (fetchTime) clearTimeout(fetchTime);
    };
  }, [apikey]);

  React.useEffect(() => {
    // apiInput.current.focus();
    console.log("apiInput = ", apiInput);
  }, []);

  return (
    <PAConnectorCard
      submitActive={submitActive}
      header={header}
      text={children}
      // appearance="lg"
      connected={connected}
      icon="slack"
    >
      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to set up Slack with Xsolla">

          <p>To enable Xsolla chat integration, first create a custom bot in Slack. Then, add the bot to the desired channels or private groups. </p>

          <ul className="manual-box__content__list-numbers">
            <li>
              Go to {" "}
              <a
                style={{color: '#0073f7', textDecoration: 'underline',}}
                href="https://my.slack.com/apps/A0F7YS25R-bots"
                target="_blank"
              >{" "}
                Slack Bots App
              </a>{" "}
              page.
            </li>


            <li>Click "Add to Slack."</li>

            <li>
              Choose a bot name (e.g., Xsolla-bot) and click "Add bot integration."
            </li>

            <li>
              Copy the API token for your bot.
            </li>
          </ul>

        </PAinfoCollapsible>
      </FormGroup>

      <FormGroup
        label="Slack API token"
        indentation="md"
        // tooltip="You can find API key in your MailChimp account"
      >
        <Input
          input={{
            ref: apiInput,
            name: "small",
            value: apikey,
            onChange: (e: SyntheticInputEvent<HTMLInputElement>) =>
              setApikey(e.target.value)
          }}
          disabled={apikey && apikey.length === 16 ? true : false}
          offset="right"
          extra={
            !!apikey &&
            apikey.length === 16 && (
              <Icon
                name="circle-remove-mini"
                hoverable={true}
                onClick={e => {
                  setApikey(null);
                  setList(null);
                  e.target.focused = true;
                }}
              />
            )
          }
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder="Enter Slack API token"
        />
      </FormGroup>


      <FormGroup
        label='Xsolla channels'
      >

      <div className="xsui-tree-select__entries"
        style={{
          padding: '12px 16px',
          background: 'rgba(21, 10, 10, .02)'
        }}
      >

        <FormGroup>
          <Checkbox
            name={`check_Customersupportchannel`}
            disabled={!submitActive}
            label='Customer support channel'
              input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>Discuss any payment-related issues directly with our team. You can also ask our team any questions you have or address any questions from your users.</div>
        </FormGroup>

        <FormGroup>
          <Checkbox
            name={`check_Technicalintegrationchannel`}
            label='Technical integration channel'
            disabled={!submitActive}
            input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>
            Ask our specialists any integration or product-related questions.
          </div>
        </FormGroup>

        <FormGroup>
          <Checkbox
            name={`check_Specialprojectsintegrationchannel`}
            label='Special projects integration channel'
            disabled={!submitActive}
            input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>
          Join this channel if you're looking for a customized solution or want to enable special features.
          </div>
        </FormGroup>

        <FormGroup>
          <Checkbox
            name={`check_Legalquestionschannel`}
            label='Legal questions channel'
            disabled={!submitActive}
            input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>
          Ask our specialists any legal questions you may have.
          </div>
        </FormGroup>

        <FormGroup>
          <Checkbox
            name={`check_Antifraudandconversionchannel`}
            label='Anti-fraud and conversion channel'
            disabled={!submitActive}
            input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>
          Request conversion reports and discuss special anti-fraud parameters.
          </div>
        </FormGroup>

        <FormGroup>
          <Checkbox
            name={`check_Newschannel`}
            label='News channel'
            disabled={!submitActive}
            input={{
              value: true,
              onChange: () => void(0)
            }}
          />
          <div className='xsui-form-group__label'>
          Get Xsolla updates, news, release announcements and improvements to help you grow your business.
          </div>
        </FormGroup>

        </div>

      </FormGroup>


      {/* <FormGroup label='Add the bot to the channel or private group'>
      1. Open the desired channel or private group page in Slack.<br/>
      2. Click "Add App" in the Apps tab of the sidebar menu.<br/>
      3. Add the bot you created.
      </FormGroup> */}



    </PAConnectorCard>
  );
}

export function PAconnectorMCH({
  connected = false,
  header = "Mailchimp",
  children = `Sync users with MailChimp`,
  handleSubmitButton = () => {
    void 0;
  }
}) {
  // let requiredFields = [
  //   apikey,
  //   list
  // ]

  let [apikey, setApikey] = React.useState(null);
  let [list, setList] = React.useState();
  let [submitActive, setSubmitActive] = React.useState(false);

  let [fetching, setFetching] = React.useState(false);

  let apiInput = React.createRef();

  let fetchTime = null;

  React.useEffect(() => {
    let active = true;
    // [apikey, list].forEach((oneReq, ind)=> {
    //   if (!oneReq) active = false;
    // })
    if (!apikey || (apikey && apikey.length !== 16)) active = false;
    if (!list) active = false;

    if (apikey && apikey.length === 16 && !fetching) {
      setFetching(true);
      fetchTime = setTimeout(() => {
        setFetching(false);
      }, 800);
    }
    console.log("fetching = ", fetching);
    setSubmitActive(active);
    return () => {
      if (fetchTime) clearTimeout(fetchTime);
    };
  }, [apikey, list]);

  React.useEffect(() => {
    // apiInput.current.focus();
    console.log("apiInput = ", apiInput);
  }, []);

  return (
    <PAConnectorCard
      submitActive={submitActive}
      header={header}
      text={children}
      connected={connected}
      icon="mailchimp"
    >
      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to set up Mailchimp export">
          <ul className="manual-box__content__list-numbers">
            <li>
              <b>Get your Mailchimp API key.</b> You can find it in your{" "}
              <a
                href="https://admin.mailchimp.com/account/api-key-popup"
                target="_blank"
              >
                Mailchimp account
              </a>
              .
            </li>
            <li>Select a list to sync your audience with.</li>
            <li>
              <span>
                Click <b>Connect</b> to save changes and start exporting Login
                users to the Mailchimp account. The audience with specified name
                will be created automatically.
              </span>
            </li>
          </ul>
          <span>
            Every time you add new Login users, they will be exported to
            Mailchimp automatically.
          </span>
        </PAinfoCollapsible>
      </FormGroup>

      <FormGroup
        label="Mailchimp API key"
        indentation="md"
        // tooltip="You can find API key in your MailChimp account"
      >
        <Input
          input={{
            ref: apiInput,
            name: "small",
            value: apikey,
            onChange: (e: SyntheticInputEvent<HTMLInputElement>) =>
              setApikey(e.target.value)
          }}
          disabled={apikey && apikey.length === 16 ? true : false}
          offset="right"
          extra={
            !!apikey &&
            apikey.length === 16 && (
              <Icon
                name="circle-remove-mini"
                hoverable={true}
                onClick={e => {
                  setApikey(null);
                  setList(null);
                  e.target.focused = true;
                }}
              />
            )
          }
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder="Enter 16-symbol MailChimp API-key"
        />
      </FormGroup>

      {fetching && (
        <FormGroup
          label="Mailchimp users list"
          indentation="md"
          tooltip="An empty emails list (audience) will be created in Mailchimp"
        >
          <div className="xsui-select">
            <div className="xsui-dropdown">
              <button
                name="test"
                value
                placeholder="Select"
                disabled
                className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--empty xsui-input--read-only"
                type="button"
                data-id="test"
              >
                <img
                  width="18"
                  height="18"
                  src="https://uikit.xsolla.com/static/57d13acd0e98a391cbb0c4f8416913b4.svg"
                />{" "}
                Loading
              </button>
            </div>
          </div>
        </FormGroup>
      )}

      {!fetching && (
        <FormGroup
          label="Mailchimp users list"
          indentation="md"
          tooltip="An empty emails list (audience) will be created in Mailchimp"
        >

            <Select
              disabled={apikey && apikey.length === 16 ? false : true}
              options={[
                { label: "List 1", description: "never used", value: "1" },
                { label: "List 2", description: "never used", value: "2" },
                { label: "List 3", description: "used before", value: "3" },
                { label: "List 4", description: "used before", value: "4" }
              ]}
              searchable={false}
              autosize={false}
              size="md"
              input={{
                value: list,
                onChange: setList
              }}
            />

        </FormGroup>
      )}
    </PAConnectorCard>
  );
}

export function PAconnectorMCHold({
  header = "Mailchimp",
  children = `Sync users with MailChimp`
}) {
  return (
    <PAConnectorCard
      header={header}
      text={children}
      connected={false}
      icon="mailchimp"
    >
      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          <ul className="manual-box__content__list-numbers">
            <li>
              <span>Fill out the following fields:</span>
              <ul className="manual-box__content__list-alpha">
                <li>
                  <span>
                    <b>Mailchimp API key.</b> You can find it in your{" "}
                    <a
                      href="https://admin.mailchimp.com/account/api-key-popup"
                      target="_blank"
                    >
                      Mailchimp account
                    </a>
                    .
                  </span>
                </li>
                <li>
                  <span>
                    <b>Audience name.</b> The audience in Mailchimp will be
                    created with this name.
                  </span>
                </li>
                <li>
                  <span>
                    <b>Default From email address.</b> The address from which
                    emails are sent. It will be shown in the From field. If you
                    use free email services, please see{" "}
                    <a
                      href="https://mailchimp.com/help/limitations-of-free-email-addresses/"
                      target="_blank"
                    >
                      this article
                    </a>{" "}
                    for possible limitations.
                  </span>
                </li>
                <li>
                  <span>
                    <b>Default From name.</b> Email sender name. It will be
                    shown in the From field.
                  </span>
                </li>
                <li>
                  <span>
                    <b>Short reminder message.</b> A reminder about how the
                    recipient joined your audience. It is added to the email
                    signature. See the{" "}
                    <a
                      href="https://mailchimp.com/resources/what-makes-a-good-permission-reminder/"
                      target="_blank"
                    >
                      article
                    </a>{" "}
                    with Mailchimp recommendations on how to write a good
                    reminder.
                  </span>
                </li>
              </ul>
            </li>
            <li>
              <span>
                Click <b>Connect</b> to save changes and start exporting Login
                users to the Mailchimp account. The audience with specified name
                will be created automatically.
              </span>
            </li>
          </ul>
          <span>
            Every time you add new Login users, they will be exported to
            Mailchimp automatically.
          </span>
        </PAinfoCollapsible>
      </FormGroup>

      <FormGroup
        label="Mailchimp API key"
        indentation="md"
        // tooltip="You can find API key in your MailChimp account"
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder=""
        />
      </FormGroup>

      <FormGroup
        label="New Mailchimp users list name"
        indentation="md"
        tooltip="An empty emails list (audience) will be created in Mailchimp"
      >
        <Input
          input={{
            name: "small",
            value: "Users from {Project Name}",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder=""
        />
      </FormGroup>

      <FormGroup
        label="Email sender address"
        indentation="md"
        tooltip="Users will receive emails from this address"
      >
        <Input
          input={{
            name: "small",
            value: "{Partner Email}",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder=""
        />
      </FormGroup>

      <FormGroup
        label="Email sender name"
        indentation="md"
        tooltip='Users will receive emails with this name in the "From" field'
      >
        <Input
          input={{
            name: "small",
            value: "{Project Name}",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder=""
        />
      </FormGroup>

      <FormGroup
        label="Short reminder message to the user"
        indentation="md"
        tooltip="A reminder for the user about how they signed up to this list"
      >
        <Textarea
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          placeholder=""
          value="You're recieving this email because you signed up to or purchased {Project Name}"
        />
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorTW({
  header = "Twitter Pixel",
  children = "Track the actions users take after viewing or engaging with your ads on Twitter."
}) {
  return (
    <PAConnectorCard
      header={header}
      text={children}
      connected={false}
      icon="twitterPixel"
    >
      <FormGroup
        label="Twitter Pixel ID"
        indentation="md"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <Input
          input={{
            name: "small",
            value: "",
            onChange: () => {
              void 0;
            }
          }}
          size="md"
          inline={true}
          style={{ width: "100%" }}
          focused={true}
          placeholder="xxxxx"
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        // caption="Usually used for filters. Width is fixed at 164px."
      >
        <PAinfoCollapsible title="How to get your ID">
          To find the Twitter Pixel ID:{" "}
          <ol>
            <li>
              Log in to your Twitter Business profile through Twitter Analytics.
            </li>
            <li>
              Click the drop-down for <strong>More</strong> and select{" "}
              <strong>Conversion Tracking</strong>.
            </li>
          </ol>
          Website Tag ID is your Twitter Pixel ID.
        </PAinfoCollapsible>
      </FormGroup>
    </PAConnectorCard>
  );
}

export function PAconnectorWH({
  header = "Webhooks",
  children = "Receive notifications for events to automate functions, such as providing a payment status. You need to set up your server to receive webhooks."
}) {
  const [state, setState] = React.useState(1);

  const handleSteps = newStep => {
    setState(newStep);
  };

  return (
    <PAConnectorCard
      header={header}
      text={children}
      appearance="lg"
      connected={false}
      footer={false}
    >
      {state === 1 && (
        <div>
          <div>
            <div>
              <FormGroup label="Webhook URL">
                <Input
                  input={{
                    value:
                      "https://secure.xsolla.com/api/calc/billing/sample.universal.php",
                    onChange: () => {
                      void 0;
                    }
                  }}
                  defaultValue="https://secure.xsolla.com/api/calc/billing/sample.universal.php"
                />
              </FormGroup>

              <FormGroup>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gridColumnGap: "16px"
                    // gridRowGap: '16px',
                  }}
                >tips
                  <FormGroup label="User ID" tooltip="What's this">
                    <Input
                      // size="sm"
                      name="basic-input"
                      input={{
                        value: "0",
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </FormGroup>

                  <FormGroup label="Xsolla Invoice ID" tooltip="What's this">
                    <Input
                      // size="sm"
                      name="basic-input"
                      input={{
                        value: "0",
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </FormGroup>

                  <FormGroup label="Amount" tooltip="What's this">
                    <Input
                      // size="sm"
                      name="basic-input"
                      input={{
                        value: "0",
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </FormGroup>

                  <FormGroup label="Currency" tooltip="What's this">

                      <Select
                        options={[
                          { label: "All", value: "all" },
                          { label: "USD", value: "USD" },
                          { label: "EUR", value: "EUR" },
                          { label: "RUB", value: "EUR" }
                        ]}
                        searchable={false}
                        autosize={false}
                        // size="sm"
                        input={{
                          name: "test",
                          value: 1,
                          onChange: () => {
                            void 0;
                          }
                        }}
                      />

                  </FormGroup>

                  <FormGroup label="Game key" tooltip="What's this">
                    <Input
                      // size="sm"
                      name="basic-input"
                      input={{
                        value: "0",
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </FormGroup>

                  <FormGroup label="Invoice ID" tooltip="What's this">
                    <Input
                      // size="sm"
                      name="basic-input"
                      input={{
                        value: "0",
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </FormGroup>
                </div>
              </FormGroup>
            </div>

            <FormFooter sticky={true}>
              <Button
                appearance="secondary"
                type="submit"
                onClick={e => {
                  handleSteps(state + 1);
                }}
              >
                Test Webhooks
              </Button>
            </FormFooter>
          </div>
        </div>
      )}

      {state === 2 && (
        <div>
          <div style={{ width: "100%" }}>
            <div className="testing-results__sandbox-url">
              <div className="xsui-typography--subheader-2">Sandbox URL</div>
              <a
                href="https://sandbox-secure.xsolla.com/paystation2/?access_token=qept0LJ6YahQU4xUC1FBNdxs1VAxwX1t"
                className="testing-results__sandbox-url__link"
                target="_blank"
              >
                https://sandbox-secure.xsolla.com/paystation2/?access_token=qept0LJ6YahQU4xUC1FBNdxs1VAxwX1t
              </a>
            </div>

            <div className="test-result">
              <div className="test-result__header">
                {/* Payment validation: Testing response to correct payment */}
                <span className="test-result__header__title">
                  Testing response to correct payment
                </span>
                <div className="test-result__header__description">
                  When Xsolla requests a payment with correct parameters, the
                  project must respond with HTTP code 200. This tester requests
                  to make a payment to an existing user.
                </div>
                <div className="test-result__header__description">
                  <span>Total attempts: 2</span>
                </div>
              </div>
              <div className="test-result__body">
                <div className="webhooks-block__form">
                  <div className="test-result__body__attempt">
                    <div className="test-result__body__attempt__status">
                      <div className="xsui-status-dot xsui-status-dot--enabled">
                        <div className="xsui-status-dot__icon" />
                        <div className="xsui-status-dot__entry" />
                      </div>
                      <span>Attempt 1</span>
                    </div>

                    <Collapse
                      isOpened={false}
                      staticElements={0}
                      collapsedLabel={count => `Show details`}
                      expandedLabel={() => "Hide details"}
                    >
                      {[
                        <FormGroup>
                          <div>
                            <div className="http__tabs">
                              <div className="http__tabs__tab">Request</div>
                              <div className="http__tabs__tab http__tabs__tab--active">
                                Response
                              </div>
                            </div>
                            <div className="http__content">
                              <div className="http__content__headers">
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    HTTP/1.1 204 No Content
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Server
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    nginx
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Date
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    Wed, 24 Apr 2019 16:54:56 GMT
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Content-Type
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    text/html; charset=UTF-8
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Connection
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    keep-alive
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    X-NewRelic-App-Data
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    PxQGUFZRDQETVVhTAQAOREgTYVYAMhEDXhFZAUxRW1xvSmwTWD0cAxRfa05MQRQDHlRRUgcBG1ZKAQYCW15PTwFOGgAIAVFXAVRbUlVVUlpSBwdDSgVZX0MBPA==
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Timing-Allow-Origin
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    *
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Pragma
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    no-cache
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Cache-Control
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    no-cache, no-store, must-revalidate,
                                    max-age=0
                                  </div>
                                </div>
                                <div className="http__content__headers__item">
                                  <div className="http__content__headers__item__key">
                                    Set-Cookie
                                  </div>
                                  <div className="http__content__headers__item__value">
                                    split_mode=0;Max-age=600;path=/
                                  </div>
                                </div>
                              </div>
                              <div className="http__content__body">
                                Not enough data available
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      ]}
                    </Collapse>
                  </div>
                </div>
                <div className="webhooks-block__form">
                  <div className="test-result__body__attempt">
                    <div className="test-result__body__attempt__status">
                      <StatusDot status="error" />
                      <span>Attempt 2</span>
                    </div>

                    <Collapse
                      isOpened={true}
                      staticElements={0}
                      collapsedLabel={count => `Show details`}
                      expandedLabel={() => "Hide details"}
                    >
                      {[
                        <FormGroup>
                          <div>
                            <div>
                              <div className="http__tabs">
                                <div className="http__tabs__tab">Request</div>
                                <div className="http__tabs__tab http__tabs__tab--active">
                                  Response
                                </div>
                              </div>
                              <div className="http__content">
                                <div className="http__content__headers">
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      HTTP/1.1 204 No Content
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Server
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      nginx
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Date
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      Wed, 24 Apr 2019 16:54:56 GMT
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Content-Type
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      text/html; charset=UTF-8
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Connection
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      keep-alive
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      X-NewRelic-App-Data
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      PxQGUFZRDQETVVhTAQAOREgTYVYAMhEDXhFZAUxRW1xvSmwTWD0cAxRfa05MQRQDHlRRUgcBG1ZKAQYBW1dPTwFOGgNcCgdXBAcPAFVQBFUBVQRDSgVZX0MBPA==
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Timing-Allow-Origin
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      *
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Pragma
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      no-cache
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Cache-Control
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      no-cache, no-store, must-revalidate,
                                      max-age=0
                                    </div>
                                  </div>
                                  <div className="http__content__headers__item">
                                    <div className="http__content__headers__item__key">
                                      Set-Cookie
                                    </div>
                                    <div className="http__content__headers__item__value">
                                      split_mode=0;Max-age=600;path=/
                                    </div>
                                  </div>
                                </div>
                                <div className="http__content__body">
                                  Not enough data available
                                </div>
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      ]}
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>

            <div className="xsui-form-footer xsui-form-footer--down xsui-form-footer--centered xsui-form-footer--sticky">
              <div className="xsui-form-footer__entry">
                <Button
                  style={{
                    position: "absolute",
                    left: 0,
                    color: "#747e8a"
                  }}
                  appearance="flatten"
                  onClick={e => {
                    handleSteps(state - 1);
                  }}
                >
                  <Icon name="chevron-reverse" />
                </Button>

                <button
                  className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                  type="submit"
                  // onClick={() => closeModal(true)}
                >
                  Use Webhooks
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </PAConnectorCard>
  );
}






export function PAconnectorInv({
  header = "Cross-platform inventory",
  children = `Allow players to have one profile, trophies and unventory across PC and Xbox`,
}) {
  return (
    <PAConnectorCard
      appearance="lg"
      header={header}
      text={children}
      connected={false}
      icon="xboxInv"
    >
      <FormGroup border="lg">
        <FormGroup
          label="Xbox Auth Key"
          indentation="md"
          // caption="Usually used for filters. Width is fixed at 164px."
        >
          <Input
            input={{
              name: "small",
              value: "",
              onChange: () => {
                void 0;
              }
            }}
            size="md"
            inline={true}
            style={{ width: "100%" }}
            focused={true}
            placeholder="XBX-XXXXXXXXX"
          />
        </FormGroup>

        <FormGroup
          indentation="lg"
          // caption="Usually used for filters. Width is fixed at 164px."
        >
          <PAinfoCollapsible title="How to get your ID">
            How to find Xbox Auth Key:
            <ol>
              <li>
                Log in to Facebook and go to your{" "}
                <a
                  style={{color: '#0073f7', textDecoration: 'underline',}}
                  href="https://www.facebook.com/ads/manager" target="_blank">
                  Ads Manager account
                </a>
              </li>
              <li>Open the Navigation Bar and select Pixels.</li>
              <li>Get your Pixel ID is under your Site name.</li>
            </ol>
          </PAinfoCollapsible>
        </FormGroup>

        <FormGroup indentation="md">

            <PAh2 tag="h3" indentation="xs" title="Catalog binding"
            >
              <div style={{}}>
                <PAtabs
                  appearance="secondary"
                  active='all'
                  handleTab={nw => {
                    void(0)
                  }}
                  items={[
                    {
                      name: 'All items',
                      stateName: 'all'
                    },
                    {
                      name: 'Unbound items',
                      stateName: 'un'
                    },
                  ]}
                />
              </div>
            </PAh2>

          </FormGroup>

          {/* <Notification size="sm">Use SKU to bind</Notification> */}
          {/* <PAviItems appearance="connector" /> */}
          <PAviGroup products={vi} appearance='connector'/>
        </FormGroup>

    </PAConnectorCard>
  );
}
